import type { UseFormSetValue } from "react-hook-form";
import type { McpServerAuthType, McpServerCreateRequest } from "../types";

/**
 * Audience ↔ auth-type mapping for the create/edit page's `AudienceAuthField`:
 * how an audience choice maps to `auth_type` and when `user_source_id` is
 * cleared. Kept out of the component so the mapping and clearing rule stay
 * unit-testable.
 */

export type AudienceId = "internal" | "external" | "api_key";

export const AUTH_TYPE_TO_AUDIENCE: Record<McpServerAuthType, AudienceId> = {
  arcade: "internal",
  user_source: "external",
  arcade_header: "api_key",
};

export const AUDIENCE_TO_AUTH_TYPE: Record<AudienceId, McpServerAuthType> = {
  internal: "arcade",
  external: "user_source",
  api_key: "arcade_header",
};

/** Short audience label for the create/edit footer summary, keyed by auth type. */
export const AUDIENCE_SUMMARY_LABEL: Record<McpServerAuthType, string> = {
  arcade: "Project members",
  user_source: "External users",
  arcade_header: "API key + user header",
};

/** Clear the user source when the audience no longer needs one. */
export function clearUserSourceUnlessExternal(
  setValue: UseFormSetValue<McpServerCreateRequest>,
  authType: McpServerAuthType
) {
  if (authType !== "user_source") {
    setValue("user_source_id", null);
  }
}
